import { api } from "../App";
import { createNotification } from "../components/Notifications/Notifications";
import {
  GET_COUNTRIES,
  GET_EDUCATIONAL_STATUSES,
  GET_FORMS_OF_EDUCATION,
  GET_GROUP_NUTRITION_LIST,
  GET_GRADE_WEIGHT,
  GET_GROUP_NUTRITION_PARALLELS,
  GET_NUTRITION_GROUP,
  GET_PERIOD_NUTRITION_LIST,
  GET_NUTRITION_PERIOD,
  GET_HEALTH_GROUP,
  GET_NUTRITION_PERIOD_FILES,
  GET_NUTRITION_PERIOD_FILE,
  GET_CANTEEN_STAFF_LIST,
  GET_CANTEEN_STAFF_FILE,
  GET_CANTEEN_STAFF,
  GET_NUTRITION_PERIOD_CREATOR,
  GET_MEAL,
  GET_DISH,
  GET_MENU_ON_DATE,
  SET_CANTEEN_LOADING,
  GET_DISH_TYPE_LIST,
  GET_DISH_FILE
} from "./types";





// <----  ГРУППЫ ПИТАНИЯ ---->

export const getGroupNutritionList = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_CANTEEN_LOADING, payload: true });
    const { data } = await api.get(`/xp_eat_group`);
    dispatch({ type: GET_GROUP_NUTRITION_LIST, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  } finally {
    dispatch({ type: SET_CANTEEN_LOADING, payload: false });
  }
};
export const getParallelsForGroupNutrition = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/xp_eat_group/parallels`);
    dispatch({ type: GET_GROUP_NUTRITION_PARALLELS, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};

export const getNutritionGroup = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/xp_eat_group/${id}`);
    dispatch({ type: GET_NUTRITION_GROUP, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};

export const updateGroupNutrition = (params) => async (dispatch, getState) => {
  try {
    await api.put(`/xp_eat_group/${params.xp_key}`, params);
    await dispatch(getGroupNutritionList());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
}

export const createGroupNutrition = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/xp_eat_group`, data);
    createNotification('success', 'Успешно');
    await dispatch(getGroupNutritionList());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteGroupNutrition = (id) => async (dispatch, getState) => {
  try {
    await api.delete(`/xp_eat_group/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getGroupNutritionList());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', error.message || 'Произошла ошибка');
  }
};

// <----  ПЕРИОДЫ ПИТАНИЯ ---->

export const getPeriodNutritionList = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SET_CANTEEN_LOADING, payload: true });
    const { data } = await api.get(`/xp_eat_period`);
    dispatch({ type: GET_PERIOD_NUTRITION_LIST, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  } finally {
    dispatch({ type: SET_CANTEEN_LOADING, payload: false });
  }
};

export const getNutritionPeriod = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/xp_eat_period/${id}`);
    dispatch({ type: GET_NUTRITION_PERIOD, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};

export const updatePeriodNutrition = (id, params, image) => async (dispatch, getState) => {
  try {
    await api.put(`/xp_eat_period/${id}`, params);
    if (!!image.name) {
      await dispatch(createPeriodNutritionFile(image, id));
    }
    await dispatch(getPeriodNutritionList());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
}

export const createPeriodNutrition = (data, image) => async (dispatch, getState) => {
  try {
    const { data: result } = await api.post(`/xp_eat_period`, data);
    if (!!image) {
      await dispatch(createPeriodNutritionFile(image, result.xp_key));
    }
    createNotification('success', 'Успешно');
    await dispatch(getPeriodNutritionList());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

export const deletePeriodNutrition = (id) => async (dispatch, getState) => {
  try {
    await api.delete(`/xp_eat_period/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getPeriodNutritionList());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', error.message || 'Произошла ошибка');
  }
};


export const getPeriodNutritionFiles = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/xp_eat_period/files/${id}`);
    dispatch({ type: GET_NUTRITION_PERIOD_FILES, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    dispatch({ type: GET_NUTRITION_PERIOD_FILES, payload: null });
  }
};

export const createPeriodNutritionFile = (data, id) => async (dispatch, getState) => {
  try {
    const fd = new FormData();
    fd.append("file", data);

    await api.post(`/xp_eat_period/file/${id}`, fd);
    await dispatch(getPeriodNutritionFiles(id));
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};

export const getPeriodNutritionFile = (file_name, id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/xp_eat_period/file/${id}/${file_name}`, { responseType: 'blob' });
    const objectURL = URL.createObjectURL(data);
    dispatch({ type: GET_NUTRITION_PERIOD_FILE, payload: objectURL });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    dispatch({ type: GET_NUTRITION_PERIOD_FILE, payload: null });
  }
};

// <----  ПЕРСОНАЛ СТОЛОВОЙ ---->

export const getCanteenStaffList = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/cook_team`);
    dispatch({ type: GET_CANTEEN_STAFF_LIST, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};

export const getCanteenStaff = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/cook_team/${id}`);
    dispatch({ type: GET_CANTEEN_STAFF, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};

export const updateCanteenStaff = (id, params, image) => async (dispatch, getState) => {
  try {
    await api.put(`/cook_team/${id}`, params);
    if (!!image.name) {
      await dispatch(createCanteenStaffFile(image, id));
    }
    await dispatch(getCanteenStaffList());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
}

export const createCanteenStaff = (data, image) => async (dispatch, getState) => {
  try {
    const { data: result } = await api.post(`/cook_team`, data);
    if (!!image) {
      await dispatch(createCanteenStaffFile(image, result.id));
    }
    createNotification('success', 'Успешно');
    await dispatch(getCanteenStaffList());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteCanteenStaff = (id) => async (dispatch, getState) => {
  try {
    await api.delete(`/cook_team/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getCanteenStaffList());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', error.message || 'Произошла ошибка');
  }
};


export const createCanteenStaffFile = (data, id) => async (dispatch, getState) => {
  try {
    const fd = new FormData();
    fd.append("file", data);

    await api.post(`/cook_team/images/${id}`, fd);
    await dispatch(getCanteenStaffFile(id));
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};


export const getCanteenStaffFile = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/cook_team/images/${id}`, { responseType: 'blob' });
    const objectURL = URL.createObjectURL(data);
    dispatch({ type: GET_CANTEEN_STAFF_FILE, payload: objectURL });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    dispatch({ type: GET_CANTEEN_STAFF_FILE, payload: null });
  }
};

// <----  Меню на день ---->
// прием пищи /хедер таблицы
export const getMeal = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/xp_eat_period`);
    dispatch({ type: GET_MEAL, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};

export const getDish = (data) => async (dispatch, getState) => {
  try {
    const c_dishclass = !!data ? { c_dishclass: data.period_key } : ''
    dispatch({ type: SET_CANTEEN_LOADING, payload: true });
    const urlParams = new URLSearchParams(c_dishclass).toString();
    const { data: result } = await api.get(`/xp_dish?${urlParams}`);
    dispatch({ type: GET_DISH, payload: result });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  } finally {
    dispatch({ type: SET_CANTEEN_LOADING, payload: false });
  }
};

export const getMenuOnDate = (data) => async (dispatch, getState) => {
  try {
    const urlParams = new URLSearchParams(data).toString();
    const { data: result } = await api.get(`/xp_dish_period/menu?${urlParams}`);
    dispatch({ type: GET_MENU_ON_DATE, payload: result });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};

export const createMenu = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/xp_dish_period`, data);
    createNotification('success', 'Успешно');
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};
export const copyMenu = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/xp_dish_period/copy`, data);
    createNotification('success', 'Успешно');
    await dispatch(getMenuOnDate({ date: data.xp_date }));
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};
export const copyDishPeriod = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/xp_dish_period/date`, data);
    createNotification('success', 'Успешно');
    await dispatch(getMenuOnDate({ date: data.from_date }));
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

// <----  Блюда  ---->

export const getDishList = () => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/c_dishclass`);
    dispatch({ type: GET_DISH_TYPE_LIST, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};

export const getCanteenStaf = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/cook_team/${id}`);
    dispatch({ type: GET_CANTEEN_STAFF, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};

export const updateDish = (id, params, image) => async (dispatch, getState) => {
  try {
    await api.put(`/xp_dish/${id}`, params);
    if (!!image.name) {
      await dispatch(createDishFile(image, id));
    }
    await dispatch(getDish());
    await dispatch(getCanteenStaffList());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
}

export const createDish = (data, image) => async (dispatch, getState) => {
  try {
    const { data: result } = await api.post(`/xp_dish`, data);
    if (!!image) {
      await dispatch(createDishFile(image, result.xp_key));
    }
    createNotification('success', 'Успешно');
    await dispatch(getDish());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', "Не удалось создать запись");
  }
};

export const deleteDish = (id) => async (dispatch, getState) => {
  try {
    await api.delete(`/xp_dish/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getDish());
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    createNotification('error', error.message || 'Произошла ошибка');
  }
};


export const createDishFile = (data, id) => async (dispatch, getState) => {
  try {
    const fd = new FormData();
    fd.append("file", data);

    await api.post(`/xp_dish/${id}/file`, fd);
    await dispatch(getDishFile(id));
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
  }
};


export const getDishFile = (id) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/xp_dish/${id}/file`, { responseType: 'blob' });
    dispatch({ type: GET_DISH_FILE, payload: data });
  } catch (error) {
    console.error('Error in directoryCanteen action:', error);
    dispatch({ type: GET_DISH_FILE, payload: null });
  }
};